let url = location.hostname == 'localhost' ? 'http://localhost:3000/comments' : 'https://nintendonews.pl/comments'

function delay(time) {
    return new Promise(resolve => setTimeout(resolve, time));
}

const removeComment = (item) => {
    if (window.confirm("Czy jesteś pewien?")) {
        fetch(url + '/' + item.dataset.id, {
            method: 'delete',
            body: JSON.stringify({
                id: item.dataset.id
            }),
            headers : {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-CSRF-Token': document.querySelector("meta[name='csrf-token']").getAttribute("content")
            }
        }).then(function(response) {
            return response.json();
        }).then(function(data) {
            item.parentElement.parentElement.parentElement.remove()
        });
    }
}

const editComment = (item) => {
    if (document.getElementsByClassName('edit-form').length > 0) {
        document.getElementsByClassName('edit-form')[0].remove()
    }
    item.parentElement.parentElement.parentElement.insertAdjacentHTML(
        'afterend',
        '<form onsubmit="return false;" class="edit-form rounded-xl bg-color-grey mt-4 flex flex-col p-4 items-center w-full" id="edit-comment-form">' +
        '<div class="w-full flex justify-end"><div class="pb-2 pr-2 text-xl font-semibold cursor-pointer close-edit">X</div></div>' +
        '<textarea class="w-full h-20 p-1" name="content" maxlength="1200" form="edit-comment-form" id="edit-comment-form-content"></textarea>' +
        '<div id="submit-comment-update" class="bg-custom-red cursor-pointer w-36 h-10 rounded-xl text-white mt-2 flex justify-center items-center font-semibold"><p>ZAPISZ</p></div>' +
        '</form>'
    )
    document.getElementById('edit-comment-form-content').value = (item.parentElement.parentElement.nextSibling.nextSibling || item.parentElement.parentElement.nextSibling).textContent
    document.getElementsByClassName('close-edit')[0].addEventListener('click', function () {
        document.getElementsByClassName('close-edit')[0].parentElement.parentElement.remove()
    });

    const submitUpdate = document.getElementById('submit-comment-update')
    submitUpdate.addEventListener('click', function (event) {
        if(!event.detail || event.detail == 1){ // to prevent double click
            submitUpdate.children[0].textContent = 'Ładowanie'
            fetch(url + '/' + item.dataset.id, {
                method: 'put',
                body: JSON.stringify({
                    content: document.getElementById('edit-comment-form-content').value
                }),
                headers : {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'X-CSRF-Token': document.querySelector("meta[name='csrf-token']").getAttribute("content")
                }
            }).then(function(response) {
                return response.json();
            }).then(function(data) {
                if (data.success == false) {
                    delay(650).then(() => submitUpdate.children[0].textContent = 'ZAPISZ');
                } else {
                    delay(650).then(() => updateComment(item))
                }
            });
        }
    })
}

const addReply = (data, element) => {
    closeReply()

    let commentGroup = (element.parentElement.parentElement.parentElement.nextSibling.nextSibling || element.parentElement.parentElement.parentElement.nextSibling.nextSibling.children[1]).children[0]
    commentGroup.insertAdjacentHTML(
        'afterend',
        `<div class="comment relative bg-color-grey rounded-xl p-4 mt-4 min-h-32 flex flex-col border border-red-500" style="margin-left: ${(parseInt(element.dataset.offset) + 1) * 30}px">` +
           '<div class="absolute" style="width: 20px; background: #eaeaea; height: 1.5px; top:45px; left: -30px"></div>' +
           '<div class="flex justify-between">' +
                '<div class="flex flex-col md:flex-row mb-4 md:mb-0">' +
                    `<div class="mr-4 font-semibold">${data.nickname}</div>` +
                    `<div>${data.created_at}</div>` +
                '</div>' +
                '<div>' +
                    `<button class="edit-comment-button mr-2" data-id="${data.id}">Edytuj</button>` +
                    `<button class="delete-reply-button new-delete-reply" data-id="${data.id}">Usuń</button>` +
                '</div>' +
            '</div>' +
            `<div class="whitespace-pre-wrap">${data.content}</div>` +
        '</div>'
    )

    let buttons = document.querySelectorAll(`[data-id='${data.id}']`)
    let deleteButton = buttons[0]
    let editButton = buttons[1]
    editButton.addEventListener('click', function() {
        removeComment(editButton)
    });
    deleteButton.addEventListener('click', function () {
        editComment(deleteButton)
    })
}

const addComment = (data, element) => {
    element.children[0].textContent = 'ZAPISZ'
    document.getElementById('new-comment-content').value = ''

    element.parentElement.insertAdjacentHTML(
        'afterend',
        `<div class="comment relative bg-color-grey rounded-xl p-4 mt-4 min-h-32 flex flex-col border border-red-500">` +
                '<div class="flex justify-between">' +
                    '<div class="flex flex-col md:flex-row mb-4 md:mb-0">' +
                    `<div class="mr-4 font-semibold">${data.nickname}</div>` +
                        `<div>${data.created_at}</div>` +
                    '</div>' +
                    '<div>' +
                        `<button class="edit-comment-button mr-2" data-id="${data.id}">Edytuj</button>` +
                        `<button class="delete-reply-button new-delete-reply" data-id="${data.id}">Usuń</button>` +
                    '</div>' +
                '</div>' +
            `<div class="whitespace-pre-wrap">${data.content}</div>` +
        '</div>'
    )
    let buttons = document.querySelectorAll(`[data-id='${data.id}']`)
    let deleteButton = buttons[0]
    let editButton = buttons[1]
    editButton.addEventListener('click', function() {
        removeComment(editButton)
    });
    deleteButton.addEventListener('click', function () {
        editComment(deleteButton)
    })
}

const updateComment = (item) => {
    (item.parentElement.parentElement.nextSibling.nextSibling || item.parentElement.parentElement.nextSibling).textContent = document.getElementById('edit-comment-form-content').value
    document.getElementsByClassName('edit-form')[0].remove()
}

const closeReply = () => {
    document.getElementsByClassName('close-reply')[0].parentElement.parentElement.remove()
}

document.addEventListener("DOMContentLoaded",function(){
    [...document.querySelectorAll('.reply-button')].forEach(function(item) {
        item.addEventListener('click', function() {
            if (document.getElementsByClassName('reply-form').length > 0) {
                document.getElementsByClassName('reply-form')[0].remove()
            }
            item.parentElement.parentElement.parentElement.insertAdjacentHTML(
                'afterend',
                '<form onsubmit="return false;" class="reply-form rounded-xl bg-color-grey mt-4 flex flex-col p-4 items-center w-full" id="new-reply-comment">' +
                '<div class="w-full flex justify-end"><div class="pb-2 pr-2 text-xl font-semibold cursor-pointer close-reply">X</div></div>' +
                '<textarea class="w-full h-20 p-1" name="content" maxlength="1200" form="new-reply-comment" id="new-reply-comment-content"></textarea>' +
                '<div id="submit-reply" class="bg-custom-red cursor-pointer w-36 h-10 rounded-xl text-white mt-2 flex justify-center items-center font-semibold"><p>ZAPISZ</p></div>' +
                '</form>'
            )
            document.getElementsByClassName('close-reply')[0].addEventListener('click', function () {
                closeReply()
            });
            const submitButton = document.getElementById('submit-reply')
            submitButton.addEventListener('click', function (event) {
                if(!event.detail || event.detail == 1){ // to prevent double click
                    submitButton.children[0].textContent = 'Ładowanie'
                    fetch(url, {
                        method: 'post',
                        body: JSON.stringify({
                            parent: item.dataset.parent,
                            content: document.getElementById('new-reply-comment-content').value
                        }),
                        headers : {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json',
                            'X-CSRF-Token': document.querySelector("meta[name='csrf-token']").getAttribute("content")
                        }
                    }).then(function(response) {
                        return response.json();
                    }).then(function(data) {
                        if (data.success == false) {
                            delay(650).then(() => submitButton.children[0].textContent = 'ZAPISZ');
                        } else {
                            delay(650).then(() => addComment(data, addReply(data, item)))
                        }
                    });
                }
            })
        });
    });

    [...document.querySelectorAll('.delete-reply-button')].forEach(function(item) {
        item.addEventListener('click', function() {
            removeComment(item)
        });
    });
    const submitComment = document.getElementById('submit-comment')

    if (submitComment) {
        submitComment.addEventListener('click', function () {
            if (submitComment.children[0].textContent != 'Ładowanie' ) {
                submitComment.children[0].textContent = 'Ładowanie'
                fetch(url, {
                    method: 'post',
                    body: JSON.stringify({
                        commentable_type: submitComment.dataset.commentableType,
                        commentable_id: submitComment.dataset.commentableId,
                        content: document.getElementById('new-comment-content').value
                    }),
                    headers : {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'X-CSRF-Token': document.querySelector("meta[name='csrf-token']").getAttribute("content")
                    }
                }).then(function(response) {
                    return response.json();
                }).then(function(data) {
                    if (data.success == false) {
                        delay(650).then(() => submitComment.children[0].textContent = 'ZAPISZ');
                    } else {
                        delay(650).then(() => addComment(data, submitComment));
                    }
                })
            }
        });
    }

    [...document.querySelectorAll('.edit-comment-button')].forEach(function(item) {
        item.addEventListener('click', function() {
            editComment(item)
        });
    });
})